<template lang="pug">
div
	vue-element-loading(:active='isActive', spinner='ring', color='#428BCA')
	.form-group
		label.col-sm-3.control-label.no-padding-right(:for='name') {{ name }}
		.col-sm-4
			.control-group
				.checkbox(v-for='(d, k) in dados' :key='k')
					label(@input='updateSelect')
						input.ace(:name='name' type='checkbox' :value='d[id]' ref="check" :checked="getChecked(d)")
						span.lbl  {{ d[titulo] }}
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import req from '@/components/request'

export default {
	components: {
		VueElementLoading
	},
	props: ['value', 'name', 'url', 'params', 'id', 'titulo', 'layout', 'optionText', 'required', 'session'],
	data() {
		return {
			dados: [],
			isActive: false
		}
	},

	methods: {
		getChecked(d) {
			if (this.value) {
				if (this.value?.length) {
					return this.value.split(',').filter(i => i == d[this.id]).length
				} else {
					return false
				}
			}
			return false
		},
		updateSelect() {
			let newArray = []
			this.$refs.check.map(item => {
				if (item.checked) {
					newArray.push(item.value)
				}
			})
			this.$emit('input', newArray.toString())
		},
		getRequest() {
			if (sessionStorage.getItem(`_${this.url}`) && !this.session) {
				this.dados = JSON.parse(sessionStorage.getItem(`_${this.url}`))
			} else {
				this.isActive = true
				req(this.url, 'get', this.params).then(resp => {
					this.dados = resp
					sessionStorage.setItem(`_${this.url}`, JSON.stringify(resp))
					this.isActive = false
				})
			}
		}
	},
	mounted() {
		this.getRequest()
	}
}
</script>

<style lang="stylus" scoped>

</style>
